"use client";
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DesktopShareMenu = void 0;
const react_1 = __importDefault(require("react"));
const foundations_1 = require("../../foundations");
const Button_1 = require("../Button");
const Target_1 = require("../Target");
const DesktopShareMenu = ({ isShareMenuOpen, setIsShareMenuOpen, shareItems, buttonLabel, buttonVariant = "primary" }) => {
    const desktopIconSx = {
        alignItems: "center",
        backgroundColor: buttonVariant === "primary"
            ? "buttonBackgroundColorPrimary"
            : "buttonBackgroundColorSecondary",
        borderColor: buttonVariant === "primary"
            ? "buttonBackgroundColorPrimary"
            : "buttonBorderColorSecondary",
        borderRadius: "iconButtonBorderRadiusCircle",
        borderStyle: "solid",
        borderWidth: 1,
        color: buttonVariant === "primary"
            ? "buttonColorPrimary"
            : buttonVariant === "secondary"
                ? "buttonColorSecondary"
                : "buttonColorTertiary",
        display: "flex",
        justifyContent: "center",
        paddingX: 3,
        paddingY: 3,
        ":hover": {
            backgroundColor: "buttonHoverBackgroundColorPrimary",
            borderColor: "buttonHoverBorderColorPrimary",
            color: "buttonHoverColorPrimary"
        }
    };
    return (react_1.default.createElement(foundations_1.Box, { sx: { display: ["none", "block", "block"] }, "data-testid": "desktop-container" },
        !isShareMenuOpen && (react_1.default.createElement(foundations_1.Box, { sx: { display: "flex", alignItems: "center", height: 16 } },
            react_1.default.createElement(Button_1.Button, { variant: buttonVariant, onClick: () => setIsShareMenuOpen(true), sx: { pt: 2 }, "data-testid": "share-button-desktop" },
                buttonLabel,
                react_1.default.createElement(foundations_1.Icon, { icon: "share-fat" })))),
        react_1.default.createElement(foundations_1.Box, { sx: {
                display: "flex",
                gap: 3,
                height: isShareMenuOpen ? 16 : 0,
                alignItems: "center",
                overflow: isShareMenuOpen ? "visible" : "hidden",
                opacity: isShareMenuOpen ? 1 : 0,
                position: isShareMenuOpen ? "relative" : "absolute",
                pointerEvents: isShareMenuOpen ? "auto" : "none",
                transition: "easeOutMedium"
            }, "data-testid": "desktop-icons-wrapper" }, shareItems.map((item, index) => {
            const transformSeconds = `0.${index + 2}s`;
            return (react_1.default.createElement(Target_1.Target, { key: index, sx: Object.assign(Object.assign({}, desktopIconSx), { transition: "easeOutSlow", transitionDuration: transformSeconds, transform: isShareMenuOpen
                        ? "translateY(0px)"
                        : "translateY(50px)" }), "aria-label": item.ariaLabel, onClick: item.clickHandler, "data-testid": item.dataTestIdDesktop },
                react_1.default.createElement(foundations_1.Icon, { size: "lg", icon: item.icon })));
        }))));
};
exports.DesktopShareMenu = DesktopShareMenu;
//# sourceMappingURL=DesktopShareMenu.js.map